import React from "react";
import styles from "./inventory-quantity.module.css";
import { Tooltip } from "@/components/Tooltip/Tooltip";
import Button from "@/components/forms/Button/Button";
import IconEditGoogle from "@/components/icons/IconEditGoogle";

type InventoryQuantityProps = {
  value?: number | null;
  rowStatus: string;
  onClick?: () => void;
  className?: string;
};

const InventoryQuantity = ({
  value,
  rowStatus,
  onClick,
  className,
}: InventoryQuantityProps) => {
  if (rowStatus !== "LISTED") {
    return (
      <Tooltip
        title={"You can't modify the qty until this listing is ACTIVE"}
      >
        <Button
          disabled={true}
          className={`${styles.button} ${className}`}
          type="text"
        >
          <span className={styles.quantity}>{value}</span>
          <IconEditGoogle size={14} className={styles.icon} />
        </Button>
      </Tooltip>
    );
  }

  return (
    <Button
      onClick={onClick}
      className={`${styles.button} ${className}`}
      type="text"
    >
      <span className={styles.quantity}>{value}</span>
      <IconEditGoogle size={14} className={styles.icon} />
    </Button>
  );
};

export default InventoryQuantity;